"use strict";

exports.__esModule = true;
exports.createStorages = void 0;
var _storage = require("../utils/storage");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createStorages = api => {
  return {
    issuance: token => _storage.Storage.create({
      api,
      path: 'query.tokens.totalIssuance',
      params: [token.toChainData()]
    }),
    totalStakingBonded: () => _storage.Storage.create({
      api,
      path: 'query.homa.totalStakingBonded',
      params: []
    }),
    stakingLedgers: () => _storage.Storage.create({
      api,
      path: 'query.homa.stakingLedgers.entries',
      params: [],
      events: [{
        section: 'homa',
        method: 'LedgerBondedReset'
      }, {
        section: 'homa',
        method: 'LedgerUnlockingReset'
      }, {
        section: 'homa',
        method: 'CurrentEraBumped'
      }, {
        section: 'homa',
        method: 'CurrentEraReset'
      }]
    }),
    toBondPool: () => _storage.Storage.create({
      api,
      path: 'query.homa.toBondPool',
      params: []
    }),
    totalVoidLiquid: () => _storage.Storage.create({
      api,
      path: 'query.homa.totalVoidLiquid',
      params: []
    }),
    estimatedRewardRatePerEra: () => _storage.Storage.create({
      api,
      path: 'query.homa.estimatedRewardRatePerEra',
      params: []
    }),
    fastMatchFeeRate: () => _storage.Storage.create({
      api,
      path: 'query.homa.fastMatchFeeRate',
      params: []
    }),
    softBondedCapPerSubAccount: () => _storage.Storage.create({
      api,
      path: 'query.homa.softBondedCapPerSubAccount',
      params: []
    }),
    redeemRequests: address => _storage.Storage.create({
      api,
      path: 'query.homa.redeemRequests',
      params: [address]
    }),
    relayChainCurrentEra: () => _storage.Storage.create({
      api,
      path: 'query.homa.relayChainCurrentEra',
      params: []
    }),
    unbondings: address => _storage.Storage.create({
      api,
      path: 'query.homa.unbondings.entries',
      params: [address],
      events: [{
        section: 'homa',
        method: 'CurrentEraReset'
      }, {
        section: 'homa',
        method: 'CurrentEraBumped'
      }, {
        section: 'homa',
        method: 'RequestedRedeem'
      }, {
        section: 'homa',
        method: 'RedeemedByUnbond'
      }, {
        section: 'homa',
        method: 'RedeemedByFastMatch'
      }, {
        section: 'homa',
        method: 'RedeemRequestCancelled'
      }, {
        section: 'homa',
        method: 'WithdrawRedemption'
      }]
    }),
    commissionRate: () => _storage.Storage.create({
      api,
      path: 'query.homa.commissionRate',
      params: []
    }),
    eraFrequency: () => _storage.Storage.create({
      api,
      path: 'query.homa.bumpEraFrequency',
      params: []
    })
  };
};
exports.createStorages = createStorages;